import { render, staticRenderFns } from "./email_form.vue?vue&type=template&id=43d2219f"
import script from "./email_form.vue?vue&type=script&lang=js"
export * from "./email_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports